export const FETCH_SINGLE_DAILY_RELEASED_TESTS_REQUEST  = "FETCH_SINGLE_DAILY_RELEASED_TESTS_REQUEST";
export const FETCH_SINGLE_DAILY_RELEASED_TESTS_SUCCESS  = "FETCH_SINGLE_DAILY_RELEASED_TESTS_SUCCESS";
export const FETCH_SINGLE_DAILY_RELEASED_TESTS_FAILURE  = "FETCH_SINGLE_DAILY_RELEASED_TESTS_FAILURE";